<template>
  <v-skeleton-loader id="tech_skeleton_loader" v-for="n in repeat" :key="n" class="my-0 my-sm-0 mx-auto pa-0" :class="extraClass" :color="color" :type="type" />
</template>

<script lang="ts" setup>
import { ref } from 'vue';

// View Skeleton Loader Options Here - https://vuetifyjs.com/en/api/v-skeleton-loader/
// Define the props for the SkeletonLoader component
const props = withDefaults(
  defineProps<{
    color?: string;
    type: string | string[];
    repeat?: number;
    extraClass?: string;
  }>(),
  {
    repeat: 1,
  }
);

const extraClass = ref(props.extraClass ?? '');
</script>

<style lang="scss">
// Global Skeleton Loader Styles
#tech_skeleton_loader {
  border-radius: 8px;
  width: 100%;

  * {
    border-radius: 8px;
  }

  // Skeleton Loader Avatar Styles
  .v-skeleton-loader__avatar {
    border-radius: 50% !important;
    max-height: 32px;
    min-height: 32px;
    height: 32px;
    max-width: 32px;
    min-width: 32px;
    width: 32px;
    margin: 6px 12px;
  }
  .v-skeleton-loader__list-item-avatar {
    padding: 5px 0px;
    flex-wrap: nowrap;
    border-radius: 0px;
  }

  // Skeleton Loader Text Styles
  .v-skeleton-loader__text {
    border-radius: 12px !important;
  }

  // > :first-child {
  //   border-top-left-radius: 8px !important;
  //   border-top-right-radius: 8px !important;
  // }

  // > :last-child {
  //   border-bottom-left-radius: 8px !important;
  //   border-bottom-right-radius: 8px !important;
  // }

  // Skeleton Loader Image Styles
  .v-skeleton-loader__image {
    border-radius: 8px 8px 0px 0px !important;
  }

  .v-skeleton-loader__bone::after {
    animation: loading 2.5s infinite !important;
    background: linear-gradient(90deg, rgba(var(--v-theme-surface), 0), rgba(var(--v-theme-surface), 0.1), rgba(var(--v-theme-surface), 0)) !important;
  }
}
</style>
